import React, { useState, useEffect } from "react";

const RotatingTaglines = () => {
  const [currentTagline, setCurrentTagline] = useState(0);
  const [displayText, setDisplayText] = useState("");

  const taglines = [
    "Backend Developer Attempting Frontend",
    "Where Bugs Become Features",
    "CSS Survivor & JavaScript Enthusiast",
    "Turning Coffee Into Code Since 2020",
    "Full Stack Developer (Frontend Still Loading...)",
    "Making Responsive Design Responsive to Therapy",
    "API Expert, UI Learning in Progress",
    "console.log('Hello, From NOOB!')",
  ];

  useEffect(() => {
    const currentText = taglines[currentTagline];
    let index = 0;

    const typeInterval = setInterval(() => {
      setDisplayText(currentText.slice(0, index + 1));
      index++;

      if (index > currentText.length) {
        clearInterval(typeInterval);

        // Wait 2s before moving to next tagline
        setTimeout(() => {
          setCurrentTagline((prev) => (prev + 1) % taglines.length);
        }, 2000);
      }
    }, 150);

    return () => clearInterval(typeInterval);
  }, [currentTagline]);

  return (
    <div className="text-center mt-10">
      <div className="h-8 flex items-center justify-center">
        <h2 className="text-xl md:text-2xl lg:text-3xl font-fira text-primary">
          {displayText}
          <span className="animate-pulse text-terminal-cyan">|</span>
        </h2>
      </div>
      <div className="mt-4 text-muted-foreground text-sm font-source">
        <span className="inline-block animate-bounce">↓</span>
        <span className="mx-2 mt-2">Scroll down to explore the chaos</span>
        <span className="inline-block animate-bounce">↓</span>
      </div>
    </div>
  );
};

export default RotatingTaglines;
